import axios from 'axios';
export default function exportProject(id, userName) {
    axios.get('/api/report/site/export/excel/' + id, {responseType: 'arraybuffer'})
        .then(response => {
            let blob = new Blob([response.data], { type: 'application/zip' });
            let link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = `${userName} Site Export ${Date.now()}`;
            link.click();
            link.remove();
        });
}
